import { action } from "typesafe-actions";

export interface IMessage {
    body?: string,
    key: string,
    type?: "info" | "error" | "blocked" | "severeWarning" | "success" | "warning",
    messages?: any[],
}

export interface IMessagesState {
    messagesStack: Array<IMessage>
}

const initialState: IMessagesState = {
    messagesStack: []
};

export enum actionTypes {
    ADD_TO_STACK = "ADD_TO_STACK",
    DELETE_FROM_ACTIVE = "DELETE_FROM_ACTIVE",
    DELETE_LAST = "DELETE_LAST",
}

export const actions = {
    addToStack: (payload: IMessage) => action(actionTypes.ADD_TO_STACK, payload),
    deleteFromActive: (payload: any) => action(actionTypes.DELETE_FROM_ACTIVE, payload),
    deleteLast: () => action(actionTypes.DELETE_LAST),
};

const reducer = (state = initialState, action: any): IMessagesState => {
    const payload = action.payload;
    switch (action.type) {
        case (actionTypes.ADD_TO_STACK):
            return {
                ...state,
                messagesStack: [...state.messagesStack, {
                    body: payload.messages[0],
                    key: payload.key,
                    type: payload.type ? payload.type : "error",
                    messages: payload.messages
                }]
            };
        case (actionTypes.DELETE_FROM_ACTIVE):
            const updatedStack = state.messagesStack.reduce((result: Array<IMessage>, message) => message.key !== payload.key ? [...result, message] : result, []);
            return {
                ...state,
                messagesStack: updatedStack
            };
        case(actionTypes.DELETE_LAST):
            const messagesStack = [
                ...state.messagesStack.slice(1)
            ];
            return {
                ...state,
                messagesStack
            };
        default:
            return state;
    }
};

export default reducer;